interface SiblingComparableSection {
  uuid: string
  parentSection?: { uuid: string } | null
}

/**
 * The current Section's siblings - the sections that share its parent (all
 * top-level sections when it has none). The Section dropdowns switch between
 * siblings; a Section's own children are reached by navigating into it, not
 * from those dropdowns.
 */
export function getSiblingSections<T extends SiblingComparableSection>(
  sections: T[],
  currentSectionUUID: string
): T[] {
  const currentParentUUID =
    sections.find(section => section.uuid === currentSectionUUID)?.parentSection
      ?.uuid ?? null

  return sections.filter(
    section => (section.parentSection?.uuid ?? null) === currentParentUUID
  )
}
